import { useMemo } from 'react'

import { useQuery } from '@apollo/client'
import { isNull, omitBy } from 'lodash'

import { GET_CLIENT_CONFIG } from 'graphql/queries'

const defaultClientConfig: ClientConfig = {
  showBillingPortal: false,
  showLocale: false,
  showClientPages: false,
  ssoOrgId: '',
  disableEmailTaskType: false,
  workosOrganizationId: null,
  disablePermissions: false,
  enableSessionTracking: false,
  hrisIntegrationSystem: '',
  showDocusignTab: false,
  showNotificationOptOut: false,
  showApiKeyTab: false,
  showUpnAndEmployeeIdInputs: false,
  enableFilterByTaxonomies: false,
  enableTaxonomyOrMatching: false,
  enableTaxonomyBlankFilter: false,
  showDelegable: false,
  slackEnterprise: false,
  showUserTemplateRoleAssignment: false,
  showConfidentialNewHire: false,
  hideExportEmployees: false,
  enableMultipleTaxonomyTermsOnEmployee: false,
  enableSendsafely: false,
  enableSelectHrisIntegrationSystem: false,
  enableDocebo: false,
  disableSingleTaskSurvey: false,
  enableEditButton: false,
  showCalendarResource: false,
  multipleCalendarAccount: false,
  alwaysShowBothDayTypes: false,
  useExternalUsersForRoleAssignments: false,
  excludeSlackSendMessageToUser: false,
  excludeSlackSendMessageToChannel: false,
  excludeSlackChannelInvite: false,
  excludeSlackGroupInvite: false,
  excludeSlackKickUser: false,
  enableNewHome: false,
  enableAiRoleplay: false,
  enableReportAiChat: false,
  enableStandaloneAssignment: false,
  enableEnablementPartners: false,
  showContent: false,
  aiChatModel: null,
  enableRoleplayPromptOptimizer: false,
  enableAiPersonaHandoff: false,
  enableAiMultiPersona: false,
  enableNotes: false,
  hideExcludeSsoToggle: false,
  meetingPrepRoleplayEnabled: false,
  enableInternalRooms: false,
  showCoursesToEmployees: false,
  newCourseWindowMonths: 3,
}

const useClientConfig = () => {
  const { data, loading } = useQuery<{ clientConfig: ClientConfig }>(
    GET_CLIENT_CONFIG,
    {
      fetchPolicy: 'cache-only',
    },
  )

  return useMemo(() => {
    if (loading) {
      return { ...defaultClientConfig }
    }

    const config = omitBy(data?.clientConfig || {}, isNull)

    return {
      ...defaultClientConfig,
      ...config,
    }
  }, [data, loading])
}

export default useClientConfig
